{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Selecione um item",
  "tableResizer": "Redimensionador",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
